import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-brand-border" data-id="element-88">
      <div className="container mx-auto px-4 text-center" data-id="element-89">
        <h2 className="font-display text-3xl text-brand-orange mb-4" data-id="element-90">
          🤸‍♂️ CALISTENIA AVANZADA RESUELTA™
        </h2>
        <p className="text-brand-muted max-w-2xl mx-auto mb-8 text-sm" data-id="element-91">
          El sistema de entrenamiento N°1 para atletas de peso corporal en
          Argentina. Porque sacar trucos avanzados no debería costarte lesiones
          ni frustración constante.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-brand-muted mb-8" data-id="element-92">
          <a href="mailto:contacto@calisteniafitness.shop" className="hover:text-brand-orange transition-colors" data-id="element-93">
            contacto@calisteniafitness.shop
          </a>
          <span className="hidden md:inline" data-id="element-94">•</span>
          <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-95">
            @calisteniafitness.ar
          </a>
          <span className="hidden md:inline" data-id="element-96">•</span>
          <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-97">
            calisteniafitness.shop
          </a>
        </div>

        <p className="text-xs text-brand-border" data-id="element-98">
          © CalisteniaFitness.shop™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}